import React, {Component} from 'react';
import css from './FieldKpis.module.scss';
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import DropDown from "../../components/DropDown/DropDown";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import {fieldKpiTimeperiods, TIME_PERIOD_LAST_MONTH} from "../../helpers/timePeriods";
import setFallbackAvatar from '../../utils/setFallbackAvatar';
import axios from "axios";
import _, { forEach } from 'lodash';

/**
 * @class
 *
 * FieldKpis page.
 */
const FieldKpis = class extends Component {
    // ---------- class fields: ----------
    source = axios.CancelToken.source();

    timePeriodOptions = fieldKpiTimeperiods;

    postRequestFindLocations = {
        "limit": 20,
        "skip": 0,
        "fields": [
            "Id",
            "Name"
        ],
        "where": {
            "Active__c": true
        }
    };

    // ---------- state: ----------
    state = {
        kpisData:{},
        displayTable: [],

        THIS_WEEKSurveyTable: [],
        LAST_WEEKSurveyTable: [],
        THIS_MONTHSurveyTable: [],
        LAST_MONTHSurveyTable: [],

        THIS_WEEKInstallTable: [],
        LAST_WEEKInstallTable: [],
        THIS_MONTHInstallTable: [],
        LAST_MONTHInstallTable: [],

        THIS_WEEKInspectionTable: [],
        LAST_WEEKInspectionTable: [],
        THIS_MONTHInspectionTable: [],
        LAST_MONTHInspectionTable: [],

        THIS_WEEKElectricalTable: [],
        LAST_WEEKElectricalTable: [],
        THIS_MONTHElectricalTable: [],
        LAST_MONTHElectricalTable: [],

        locations: [
            {
                label: 'Sacramento',
                value: 'Sacramento',
                checked: true
            },
            {
                label: 'Corona',
                value: 'Corona',
                checked: true
            },
            {
                label: 'Fairfield',
                value: 'Fairfield',
                checked: true
            },
            {
                label: 'Lincoln',
                value: 'Lincoln',
                checked: true
            },
            {
                label: 'Dallas',
                value: 'Dallas',
                checked: true
            },
            {
                label: 'Riverside',
                value: 'Riverside',
                checked: true
            },
            {
                label: 'None',
                value: 'None',
                checked: true
            }
        ],
        selectedLocations: ['Sacramento', 'Corona', 'Fairfield', 'Lincoln', 'Dallas', 'Riverside', 'None'],

        sortBy: 'percentage',
        aggType: 'Survey',
        aggTime: 'LAST_MONTH',
        aggLocation: 'All'
    };

    // ---------- life cycle methods: ----------
    componentDidMount() {
        this.getFieldKpisData();
        // this.getLocations();
    }

    componentWillUnmount() {
        this.source.cancel();
    }

    getFieldKpisData = () => {
        axios.get(
            '/getHMODScoreboard',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const kpis = res.data[0]

                this.setState({kpisData: kpis.kpis});
                this.aggregateKPIData(kpis.kpis);
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(GET) Error in HMOD Scoreboard: \n', err);
                }
            });
    };

    getLocations = () => {
        return axios.post(
            '/sf/location/findNo',
            this.postRequestFindLocations,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records;
                let tempAray = [];

                data.forEach(location => {
                    let office = {
                        label: location.Name,
                        value: location.Name,
                        checked: true
                    }

                    tempAray.push(office);
                });

                this.setState({locations: tempAray});
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(GET) Error getting Locations: \n', err);
                }
            });
    };

    aggregateKPIData = (kpis) => {
        let THIS_WEEKSurveyTable = [];
        let LAST_WEEKSurveyTable = [];
        let THIS_MONTHSurveyTable = [];
        let LAST_MONTHSurveyTable = [];

        let THIS_WEEKInstallTable = [];
        let LAST_WEEKInstallTable = [];
        let THIS_MONTHInstallTable = [];
        let LAST_MONTHInstallTable = [];

        let THIS_WEEKInspectionTable = [];
        let LAST_WEEKInspectionTable = [];
        let THIS_MONTHInspectionTable = [];
        let LAST_MONTHInspectionTable = [];

        let THIS_WEEKElectricalTable = [];
        let LAST_WEEKElectricalTable = [];
        let THIS_MONTHElectricalTable = [];
        let LAST_MONTHElectricalTable = [];

        // Survey Table Agg
        _.forEach(kpis.survey.thisWeekSurveyData, function(value) {
            let data = {name: value.name, id: value.id, percentage: Math.floor((value.percentage) * 100), total: value.total, location: value.location};
            THIS_WEEKSurveyTable.push(data);
        });

        _.forEach(kpis.survey.lastWeekSurveyData, function(value) {
            let data = {name: value.name, id: value.id, percentage: Math.floor((value.percentage) * 100), total: value.total, location: value.location};
            LAST_WEEKSurveyTable.push(data);
        });

        _.forEach(kpis.survey.thisMonthSurveyData, function(value) {
            let data = {name: value.name, id: value.id, percentage: Math.floor((value.percentage) * 100), total: value.total, location: value.location};
            THIS_MONTHSurveyTable.push(data);
        });

        _.forEach(kpis.survey.lastMonthSurveyData, function(value) {
            let data = {name: value.name, id: value.id, percentage: Math.floor((value.percentage) * 100), total: value.total, location: value.location};
            LAST_MONTHSurveyTable.push(data);
        });


        // Install Table Agg
        _.forEach(kpis.install.thisWeekInstallData, function(value) {
            let data = {name: value.name, id: value.id, hmod: value.hmod ? value.hmod.toFixed(2) : 'None', passOnFirstPercentage: Math.floor((value.passOnFirstPercentage) * 100), installCount: value.installCount, location: value.location, hmodTier: 'DQ', trueHmod: 0};

            if(value.location === 'Sacramento' || value.location === 'Fairfield' || value.location === 'Lincoln'){
                if(value.hmod > 0 && value.hmod <= 2.0){
                    data.hmodTier = 1;
                } else if(value.hmod > 2.0 && value.hmod <= 2.5){
                    data.hmodTier = 2;
                } else if(value.hmod > 2.5 && value.hmod <= 3.0){
                    data.hmodTier = 3;
                }

                data.trueHmod = value.hmod + .5;
            } else if(value.location === 'Corona' || value.location === 'San Diego'){
                if(value.hmod > 0 && value.hmod <= 2.5){
                    data.hmodTier = 1;
                } else if(value.hmod > 2.5 && value.hmod <= 3.0){
                    data.hmodTier = 2;
                } else if(value.hmod > 3.0 && value.hmod <= 3.5){
                    data.hmodTier = 3;
                }

                data.trueHmod = value.hmod;
            } else if(value.location === 'Dallas' || value.location === 'Austin'){
                if(value.hmod > 0 && value.hmod <= 1.6){
                    data.hmodTier = 1;
                } else if(value.hmod > 1.6 && value.hmod <= 2.1){
                    data.hmodTier = 2;
                } else if(value.hmod > 2.1 && value.hmod <= 2.6){
                    data.hmodTier = 3;
                }

                data.trueHmod = value.hmod + .9;
            } else {
                data.trueHmod = 100;
            }

            THIS_WEEKInstallTable.push(data);
        });

        _.forEach(kpis.install.lastWeekInstallData, function(value) {
            let data = {name: value.name, id: value.id, hmod: value.hmod ? value.hmod.toFixed(2) : 'None', passOnFirstPercentage: Math.floor((value.passOnFirstPercentage) * 100), installCount: value.installCount, location: value.location, hmodTier: 'DQ', trueHmod: 0};

            if(value.location === 'Sacramento' || value.location === 'Fairfield' || value.location === 'Lincoln'){
                if(value.hmod > 0 && value.hmod <= 2.0){
                    data.hmodTier = 1;
                } else if(value.hmod > 2.0 && value.hmod <= 2.5){
                    data.hmodTier = 2;
                } else if(value.hmod > 2.5 && value.hmod <= 3.0){
                    data.hmodTier = 3;
                }

                data.trueHmod = value.hmod + .5;
            } else if(value.location === 'Corona' || value.location === 'San Diego'){
                if(value.hmod > 0 && value.hmod <= 2.5){
                    data.hmodTier = 1;
                } else if(value.hmod > 2.5 && value.hmod <= 3.0){
                    data.hmodTier = 2;
                } else if(value.hmod > 3.0 && value.hmod <= 3.5){
                    data.hmodTier = 3;
                }

                data.trueHmod = value.hmod;
            } else if(value.location === 'Dallas' || value.location === 'Austin'){
                if(value.hmod > 0 && value.hmod <= 1.6){
                    data.hmodTier = 1;
                } else if(value.hmod > 1.6 && value.hmod <= 2.1){
                    data.hmodTier = 2;
                } else if(value.hmod > 2.1 && value.hmod <= 2.6){
                    data.hmodTier = 3;
                }

                data.trueHmod = value.hmod + .9;
            } else {
                data.trueHmod = 100;
            }

            LAST_WEEKInstallTable.push(data);
        });

        _.forEach(kpis.install.thisMonthInstallData, function(value) {
            let data = {name: value.name, id: value.id, hmod: value.hmod ? value.hmod.toFixed(2) : 'None', passOnFirstPercentage: Math.floor((value.passOnFirstPercentage) * 100), installCount: value.installCount, location: value.location, hmodTier: 'DQ', trueHmod: 0};

            if(value.location === 'Sacramento' || value.location === 'Fairfield' || value.location === 'Lincoln'){
                if(value.hmod > 0 && value.hmod <= 2.0){
                    data.hmodTier = 1;
                } else if(value.hmod > 2.0 && value.hmod <= 2.5){
                    data.hmodTier = 2;
                } else if(value.hmod > 2.5 && value.hmod <= 3.0){
                    data.hmodTier = 3;
                }

                data.trueHmod = value.hmod + .5;
            } else if(value.location === 'Corona' || value.location === 'San Diego'){
                if(value.hmod > 0 && value.hmod <= 2.5){
                    data.hmodTier = 1;
                } else if(value.hmod > 2.5 && value.hmod <= 3.0){
                    data.hmodTier = 2;
                } else if(value.hmod > 3.0 && value.hmod <= 3.5){
                    data.hmodTier = 3;
                }

                data.trueHmod = value.hmod;
            } else if(value.location === 'Dallas' || value.location === 'Austin'){
                if(value.hmod > 0 && value.hmod <= 1.6){
                    data.hmodTier = 1;
                } else if(value.hmod > 1.6 && value.hmod <= 2.1){
                    data.hmodTier = 2;
                } else if(value.hmod > 2.1 && value.hmod <= 2.6){
                    data.hmodTier = 3;
                }

                data.trueHmod = value.hmod + .9;
            } else {
                data.trueHmod = 100;
            }

            THIS_MONTHInstallTable.push(data);
        });

        _.forEach(kpis.install.lastMonthInstallData, function(value) {
            let data = {name: value.name, id: value.id, hmod: value.hmod ? value.hmod.toFixed(2) : 'None', passOnFirstPercentage: Math.floor((value.passOnFirstPercentage) * 100), installCount: value.installCount, location: value.location, hmodTier: 'DQ', trueHmod: 0};

            if(value.location === 'Sacramento' || value.location === 'Fairfield' || value.location === 'Lincoln'){
                if(value.hmod > 0 && value.hmod <= 2.0){
                    data.hmodTier = 1;
                } else if(value.hmod > 2.0 && value.hmod <= 2.5){
                    data.hmodTier = 2;
                } else if(value.hmod > 2.5 && value.hmod <= 3.0){
                    data.hmodTier = 3;
                }

                data.trueHmod = value.hmod + .5;
            } else if(value.location === 'Corona' || value.location === 'San Diego'){
                if(value.hmod > 0 && value.hmod <= 2.5){
                    data.hmodTier = 1;
                } else if(value.hmod > 2.5 && value.hmod <= 3.0){
                    data.hmodTier = 2;
                } else if(value.hmod > 3.0 && value.hmod <= 3.5){
                    data.hmodTier = 3;
                }

                data.trueHmod = value.hmod;
            } else if(value.location === 'Dallas' || value.location === 'Austin'){
                if(value.hmod > 0 && value.hmod <= 1.6){
                    data.hmodTier = 1;
                } else if(value.hmod > 1.6 && value.hmod <= 2.1){
                    data.hmodTier = 2;
                } else if(value.hmod > 2.1 && value.hmod <= 2.6){
                    data.hmodTier = 3;
                }

                data.trueHmod = value.hmod + .9;
            } else {
                data.trueHmod = 100;
            }

            LAST_MONTHInstallTable.push(data);
        });


        // Inspection Table Agg
        _.forEach(kpis.inspection.thisWeekInspectionData, function(value) {
            let data = {name: value.name, id: value.id, total: value.total, passCount: value.passCount, location: value.location, passOnFirstPercentage: Math.floor((value.passOnFirstPercentage) * 100)};
            THIS_WEEKInspectionTable.push(data);
        });

        _.forEach(kpis.inspection.lastWeekInspectionData, function(value) {
            let data = {name: value.name, id: value.id, total: value.total, passCount: value.passCount, location: value.location, passOnFirstPercentage: Math.floor((value.passOnFirstPercentage) * 100)};
            LAST_WEEKInspectionTable.push(data);
        });

        _.forEach(kpis.inspection.thisMonthInspectionData, function(value) {
            let data = {name: value.name, id: value.id, total: value.total, passCount: value.passCount, location: value.location, passOnFirstPercentage: Math.floor((value.passOnFirstPercentage) * 100)};
            THIS_MONTHInspectionTable.push(data);
        });

        _.forEach(kpis.inspection.lastMonthInspectionData, function(value) {
            let data = {name: value.name, id: value.id, total: value.total, passCount: value.passCount, location: value.location, passOnFirstPercentage: Math.floor((value.passOnFirstPercentage) * 100)};
            LAST_MONTHInspectionTable.push(data);
        });


        // Electrical Table Agg
        _.forEach(kpis.electrical.thisWeekElectricalData, function(value) {
            let data = {name: value.name, id: value.id, totalHours: Math.round(value.totalHours * 100) / 100, tou: value.tou, backup: value.backup * 2.5, mpu: value.mpu * 2, service: Math.round(value.service * 100) / 100, points: Math.round((value.tou + (value.backup * 2.5) + (value.mpu * 2) + value.service) * 100) / 100, hrsPoints: 0, hrsPointDisplay: 0, location: value.location};

            if(data.totalHours > 0 && data.points > 0){
                data.hrsPoints = Math.round((data.totalHours / data.points) * 100) / 100;
                data.hrsPointDisplay = Math.round((data.totalHours / data.points) * 100) / 100;
            } else {
                data.hrsPoints = 1000;
                data.hrsPointDisplay = 'None';
            }

            THIS_WEEKElectricalTable.push(data);
        });

        _.forEach(kpis.electrical.lastWeekElectricalData, function(value) {
            let data = {name: value.name, id: value.id, totalHours: Math.round(value.totalHours * 100) / 100, tou: value.tou, backup: value.backup * 2.5, mpu: value.mpu * 2, service: Math.round(value.service * 100) / 100, points: Math.round((value.tou + (value.backup * 2.5) + (value.mpu * 2) + value.service) * 100) / 100, hrsPoints: 0, hrsPointDisplay: 0, location: value.location};

            if(data.totalHours > 0 && data.points > 0){
                data.hrsPoints = Math.round((data.totalHours / data.points) * 100) / 100;
                data.hrsPointDisplay = Math.round((data.totalHours / data.points) * 100) / 100;
            } else {
                data.hrsPoints = 1000;
                data.hrsPointDisplay = 'None';
            }

            LAST_WEEKElectricalTable.push(data);
        });

        _.forEach(kpis.electrical.thisMonthElectricalData, function(value) {
            let data = {name: value.name, id: value.id, totalHours: Math.round(value.totalHours * 100) / 100, tou: value.tou, backup: value.backup * 2.5, mpu: value.mpu * 2, service: Math.round(value.service * 100) / 100, points: Math.round((value.tou + (value.backup * 2.5) + (value.mpu * 2) + value.service) * 100) / 100, hrsPoints: 0, hrsPointDisplay: 0, location: value.location};

            if(data.totalHours > 0 && data.points > 0){
                data.hrsPoints = Math.round((data.totalHours / data.points) * 100) / 100;
                data.hrsPointDisplay = Math.round((data.totalHours / data.points) * 100) / 100;
            } else {
                data.hrsPoints = 1000;
                data.hrsPointDisplay = 'None';
            }

            THIS_MONTHElectricalTable.push(data);
        });

        _.forEach(kpis.electrical.lastMonthElectricalData, function(value) {
            let data = {name: value.name, id: value.id, totalHours: Math.round(value.totalHours * 100) / 100, tou: value.tou, backup: value.backup * 2.5, mpu: value.mpu * 2, service: Math.round(value.service * 100) / 100, points: Math.round((value.tou + (value.backup * 2.5) + (value.mpu * 2) + value.service) * 100) / 100, hrsPoints: 0, hrsPointDisplay: 0, location: value.location};

            if(data.totalHours > 0 && data.points > 0){
                data.hrsPoints = Math.round((data.totalHours / data.points) * 100) / 100;
                data.hrsPointDisplay = Math.round((data.totalHours / data.points) * 100) / 100;
            } else {
                data.hrsPoints = 1000;
                data.hrsPointDisplay = 'None';
            }

            LAST_MONTHElectricalTable.push(data);
        });

        this.setState({
            THIS_WEEKSurveyTable: _.orderBy(THIS_WEEKSurveyTable, ['percentage', 'total'], ['desc', 'desc']),
            LAST_WEEKSurveyTable: _.orderBy(LAST_WEEKSurveyTable, ['percentage', 'total'], ['desc', 'desc']), 
            THIS_MONTHSurveyTable: _.orderBy(THIS_MONTHSurveyTable, ['percentage', 'total'], ['desc', 'desc']), 
            LAST_MONTHSurveyTable: _.orderBy(LAST_MONTHSurveyTable, ['percentage', 'total'], ['desc', 'desc']),

            THIS_WEEKInstallTable: _.orderBy(_.filter(THIS_WEEKInstallTable, function(o) { return o.trueHmod != 0;}), ['trueHmod'], ['asc']), 
            LAST_WEEKInstallTable: _.orderBy(_.filter(LAST_WEEKInstallTable, function(o) { return o.trueHmod != 0;}), ['trueHmod'], ['asc']), 
            THIS_MONTHInstallTable: _.orderBy(_.filter(THIS_MONTHInstallTable, function(o) { return o.trueHmod != 0;}), ['trueHmod'], ['asc']), 
            LAST_MONTHInstallTable: _.orderBy(_.filter(LAST_MONTHInstallTable, function(o) { return o.trueHmod != 0;}), ['trueHmod'], ['asc']),

            THIS_WEEKInspectionTable: _.orderBy(THIS_WEEKInspectionTable, ['passOnFirstPercentage'], ['desc']), 
            LAST_WEEKInspectionTable: _.orderBy(LAST_WEEKInspectionTable, ['passOnFirstPercentage'], ['desc']), 
            THIS_MONTHInspectionTable: _.orderBy(THIS_MONTHInspectionTable, ['passOnFirstPercentage'], ['desc']), 
            LAST_MONTHInspectionTable: _.orderBy(LAST_MONTHInspectionTable, ['passOnFirstPercentage'], ['desc']),

            // Electrical
            THIS_WEEKElectricalTable: _.orderBy(THIS_WEEKElectricalTable, ['tou'], ['desc']), 
            LAST_WEEKElectricalTable: _.orderBy(LAST_WEEKElectricalTable, ['tou'], ['desc']), 
            THIS_MONTHElectricalTable: _.orderBy(THIS_MONTHElectricalTable, ['tou'], ['desc']), 
            LAST_MONTHElectricalTable: _.orderBy(LAST_MONTHElectricalTable, ['tou'], ['desc']),

            displayTable: _.orderBy(LAST_MONTHSurveyTable, ['percentage', 'total'], ['desc', 'desc'])
        });
    };

    sortButtonCss = (property) => {
        return `btn flex-grow-1 mr-1 ${this.state.sortBy === property ? 'btn-primary' : 'btn-outline'}`;
    };

    sortByProperty = (property) => {
        // prevent user from clicking before data has been loaded (would throw error):
        if (!this.state.kpisData) {
            return;
        }

        let displayedTable = _.cloneDeep(this.state.displayTable);

        this.setState({
            sortBy: property,
            displayTable: _.orderBy(displayedTable, [property], property === 'hmod' || property === 'trueHmod' || property === 'hrsPoints' ? ['asc'] : ['desc'])
        });
    };

    aggregateButtonCss = (facet) => {
        return `btn flex-grow-1 mr-1 ${this.state.aggType === facet ? 'btn-primary' : 'btn-outline'}`;
    };

    tableCellCss = (property) => {
        return this.state.sortBy === property ? css.FieldKpis__Table__Sorted : '';
    };

    tableRankStyleObj = (index) => {
        let styleObj;

        if (index < 9) {
            styleObj = {fontSize: '12px'};
        } else if (index < 99) {
            styleObj = {fontSize: '11px', paddingRight: '3px'};
        } else {
            styleObj = {fontSize: '9px', paddingRight: '3px'};
        }

        return styleObj;
    };

    aggregateButtonOnClick = (facet) => {
        // prevent user from clicking before data has been loaded (would throw error):
        if (!this.state.kpisData) {
            return;
        }

        switch(facet) {
            case 'Survey':
                let tableName = this.state.aggTime + 'SurveyTable';
                let tableSurvey = this.state[tableName];
                let filterTableSurvey = _.filter(tableSurvey, item => this.state.selectedLocations.includes(item.location));

                this.setState({
                    displayTable: _.orderBy(filterTableSurvey, ['percentage'], ['desc']),
                    aggType: 'Survey',
                    sortBy: 'percentage'
                })
                break;
            case 'Install':
                let tableInstallName = this.state.aggTime + 'InstallTable';
                let tableInstall = this.state[tableInstallName];
                let filterTableInstall = _.filter(tableInstall, item => this.state.selectedLocations.includes(item.location));

                this.setState({
                    displayTable: filterTableInstall,
                    aggType: 'Install',
                    sortBy: 'trueHmod'
                })
                break;
            case 'Inspection':
                let tableInspectionName = this.state.aggTime + 'InspectionTable';
                let tableInspection = this.state[tableInspectionName];
                let filterTableInspection = _.filter(tableInspection, item => this.state.selectedLocations.includes(item.location));

                this.setState({
                    displayTable: filterTableInspection,
                    aggType: 'Inspection',
                    sortBy: 'passOnFirstPercentage'
                })
                break;
            case 'Electrical':
                let tableElectricalName = this.state.aggTime + 'ElectricalTable';
                let tableElectrical = this.state[tableElectricalName];
                let filterTableElectrical = _.filter(tableElectrical, item => this.state.selectedLocations.includes(item.location));

                this.setState({
                    displayTable: filterTableElectrical,
                    aggType: 'Electrical',
                    sortBy: 'tou'
                })
                break;
            default:

                break;
        }

        // update state:
        this.setState({
            aggType: facet
        });
    };

    filterByTimePeriodOnChange = (val) =>{
        // prevent user from clicking before data has been loaded (would throw error):
        if (!this.state.kpisData) {
            return;
        }

        let property = this.state.sortBy;

        switch (val) {
            case 'THIS_WEEK':
                let tableNameTHIS_WEEK = 'THIS_WEEK' + this.state.aggType + 'Table';
                let tableTHIS_WEEK = this.state[tableNameTHIS_WEEK];
                let filterTableTHIS_WEEK = _.filter(tableTHIS_WEEK, item => this.state.selectedLocations.includes(item.location));

                this.setState({
                    displayTable: _.orderBy(_.filter(filterTableTHIS_WEEK, function(o) { return o.property != 0; }), [property], property === 'hmod' || property === 'trueHmod' || property === 'hrsPoints' ? ['asc'] : ['desc']),
                    aggTime: 'THIS_WEEK'
                })
                break;
            case 'LAST_WEEK':
                let tableNameLAST_WEEK = 'LAST_WEEK' + this.state.aggType + 'Table';
                let tableLAST_WEEK = this.state[tableNameLAST_WEEK];
                let filterTableLAST_WEEK = _.filter(tableLAST_WEEK, item => this.state.selectedLocations.includes(item.location));

                this.setState({
                    displayTable: _.orderBy(_.filter(filterTableLAST_WEEK, function(o) { return o.property != 0; }), [property], property === 'hmod' || property === 'trueHmod' || property === 'hrsPoints' ? ['asc'] : ['desc']),
                    aggTime: 'LAST_WEEK'
                })
                break;
            case 'LAST_MONTH':
                let tableNameLAST_MONTH = 'LAST_MONTH' + this.state.aggType + 'Table';
                let tableLAST_MONTH = this.state[tableNameLAST_MONTH];
                let filterTableLAST_MONTH = _.filter(tableLAST_MONTH, item => this.state.selectedLocations.includes(item.location));

                this.setState({
                    displayTable: _.orderBy(_.filter(filterTableLAST_MONTH, function(o) { return o.property != 0; }), [property], property === 'hmod' || property === 'trueHmod' || property === 'hrsPoints' ? ['asc'] : ['desc']),
                    aggTime: 'LAST_MONTH'
                })
                break;
            case 'THIS_MONTH':
                let tableNameTHIS_MONTH = 'THIS_MONTH' + this.state.aggType + 'Table';
                let tableTHIS_MONTH = this.state[tableNameTHIS_MONTH];
                let filterTableTHIS_MONTH = _.filter(tableTHIS_MONTH, item => this.state.selectedLocations.includes(item.location));

                this.setState({
                    displayTable: _.orderBy(_.filter(filterTableTHIS_MONTH, function(o) { return o.property != 0; }), [property], property === 'hmod' || property === 'trueHmod' || property === 'hrsPoints' ? ['asc'] : ['desc']),
                    aggTime: 'THIS_MONTH'
                })
                break;
            default:
                break;
        }
    };

    filterByLocationChange = (optionList) => {
        // prevent user from clicking before data has been loaded (would throw error):
        if (!this.state.kpisData) {
            return;
        }

        let property = this.state.sortBy;

        const selectedLocations = optionList
            .filter(item => item.checked)
            .map(item => item.value);

        let tableName = this.state.aggTime + this.state.aggType + 'Table';

        let table = this.state[tableName];

        this.setState({
            locations: optionList, selectedLocations,
            displayTable: _.orderBy(_.filter(table, item => selectedLocations.includes(item.location)), [property], property === 'hmod' || property === 'trueHmod' ? ['asc'] : ['desc'])
        })
    };

    render() {
        return (
            <div className={css.FieldKpis}>
                {/* TODO: need to not make heading always uppercase - because "s" in "KPIs" should be lowercase: */}
                <SectionHeading heading="Field KPIs" subheading="Refreshed Every 30 Minutes" />

                {/* ---------- facets/filters row: ---------- */}
                <div className="row">
                    <div className="col-12 col-sm-6">
                        <h4>Type</h4>
                        <div className="d-block d-md-none">
                            <button className={this.aggregateButtonCss('Survey')} type="button" onClick={() => this.aggregateButtonOnClick('Survey')}>Survey</button>
                            <button className={this.aggregateButtonCss('Install')} type="button" onClick={() => this.aggregateButtonOnClick('Install')}>Inst</button>
                            <button className={this.aggregateButtonCss('Inspection')} type="button" onClick={() => this.aggregateButtonOnClick('Inspection')}>Insp</button>
                            <button className={this.aggregateButtonCss('Electrical')} type="button" onClick={() => this.aggregateButtonOnClick('Electrical')}>Elec</button>
                        </div>
                        <div className="d-none d-md-block">
                            <button className={this.aggregateButtonCss('Survey')} type="button" onClick={() => this.aggregateButtonOnClick('Survey')}>Survey</button>
                            <button className={this.aggregateButtonCss('Install')} type="button" onClick={() => this.aggregateButtonOnClick('Install')}>Install</button>
                            <button className={this.aggregateButtonCss('Inspection')} type="button" onClick={() => this.aggregateButtonOnClick('Inspection')}>Inspection</button>
                            <button className={this.aggregateButtonCss('Electrical')} type="button" onClick={() => this.aggregateButtonOnClick('Electrical')}>Electrical</button>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 mt-3 mt-sm-0">
                        <h4>When</h4>
                        <DropDown
                            options={this.timePeriodOptions}
                            onDropdownSelect={(val) => this.filterByTimePeriodOnChange(val)}
                            default={TIME_PERIOD_LAST_MONTH}
                        />
                    </div>
                </div>

                {/* ---------- facets/filters row 2: ---------- */}
                <div className="row mt-4">
                    <div className="col-sm-12 col-md-6">
                        {/* TODO: On Leads and Customers, the sorting is done when user clicks on table header column.
                            TODO: We should replace buttons with sort on header click: */}
                        <h4>Sort</h4>
                        {
                            this.state.aggType === 'Survey' ?
                            <div className="d-inline">
                                <button className={this.sortButtonCss('percentage')} type="button" onClick={() => this.sortByProperty('percentage')}>Complete %</button>
                                <button className={this.sortButtonCss('total')} type="button" onClick={() => this.sortByProperty('total')}>Total</button>
                            </div>
                            :
                            this.state.aggType === 'Install' ?
                            <div className="d-inline">
                                <button className={this.sortButtonCss('trueHmod')} type="button" onClick={() => this.sortByProperty('trueHmod')}>Tier</button>
                                <button className={this.sortButtonCss('hmod')} type="button" onClick={() => this.sortByProperty('hmod')}>HMOD</button>
                                <button className={this.sortButtonCss('passOnFirstPercentage')} type="button" onClick={() => this.sortByProperty('passOnFirstPercentage')}>Pass %</button>
                                <button className={this.sortButtonCss('installCount')} type="button" onClick={() => this.sortByProperty('installCount')}>Installs</button>
                            </div>
                            :
                            this.state.aggType === 'Inspection' ?
                            <div className="d-inline">
                                <button className={this.sortButtonCss('passOnFirstPercentage')} type="button" onClick={() => this.sortByProperty('passOnFirstPercentage')}>FPR</button>
                                <button className={this.sortButtonCss('passCount')} type="button" onClick={() => this.sortByProperty('passCount')}>Pass</button>
                            </div>
                            :
                            this.state.aggType === 'Electrical' ?
                            <div className="d-inline">
                                <button className={this.sortButtonCss('tou')} type="button" onClick={() => this.sortByProperty('tou')}>TOU</button>
                                <button className={this.sortButtonCss('backup')} type="button" onClick={() => this.sortByProperty('backup')}>Backup</button>
                                <button className={this.sortButtonCss('mpu')} type="button" onClick={() => this.sortByProperty('mpu')}>MPU</button>
                                <button className={this.sortButtonCss('service')} type="button" onClick={() => this.sortByProperty('service')}>Service</button>
                                <button className={this.sortButtonCss('hrsPoints')} type="button" onClick={() => this.sortByProperty('hrsPoints')}>Hrs/Points</button>
                            </div>
                            :
                            ''
                        }
                    </div>
                    <div className="col-sm-12 col-md-6 mt-3 mt-md-0">
                        <h4>Where</h4>
                        <CheckboxDropDown
                            options={this.state.locations}
                            onDropdownSelect={(options) => this.filterByLocationChange(options)}
                            text="Location"
                        />
                    </div>
                </div>

                {/* ---------- table: ---------- */}
                {
                    this.state.aggType === 'Survey' ?
                    <table className={`${css.FieldKpis__Table} mt-5`}>
                        <thead>
                        <tr>
                            <th colSpan="2">Field Tech</th>
                            <th className={this.tableCellCss('percentage')}><span>Complete%</span></th>
                            <th className={this.tableCellCss('total')}><span>Total</span></th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            // ----- table rows: -----
                            this.state.displayTable
                                // map array to markup:
                                .map((tech, index) => {
                                    return (
                                        <tr key={tech.id}>
                                            <td>
                                                <div className={css.FieldKpis__Table__AvatarContainer}>
                                                    <img src={`https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/repPhotos/${tech.name}.jpg`} alt='Sales Rep Portrait' onError={(event) => setFallbackAvatar(event)} />
                                                    <span style={this.tableRankStyleObj(index+1)}>{index+1}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <>
                                                    <div>{tech.name}</div>
                                                    <div className="text-sm text-uppercase mt-2 mt-sm-0">{tech.location}</div>
                                                </>
                                            </td>
                                            <td className={this.tableCellCss('percentage')}>{tech.percentage}%</td>
                                            <td className={this.tableCellCss('total')}>{tech.total}</td>
                                        </tr>
                                    );
                                })
                        }
                        </tbody>
                    </table>
                    :
                    this.state.aggType === 'Install' ?
                    <table className={`${css.FieldKpis__Table} mt-5`}>
                        <thead>
                        <tr>
                            <th colSpan="2">Field Tech</th>
                            <th className={this.tableCellCss('trueHmod')}><span>Tier</span></th>
                            <th className={this.tableCellCss('hmod')}><span>HMOD</span></th>
                            <th className={this.tableCellCss('passOnFirstPercentage')}><span>Pass%</span></th>
                            <th className={this.tableCellCss('installCount')}><span>Installs</span></th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            // ----- table rows: -----
                            this.state.displayTable
                                // map array to markup:
                                .map((tech, index) => {
                                    return (
                                        <tr key={tech.id}>
                                            <td>
                                                <div className={css.FieldKpis__Table__AvatarContainer}>
                                                    <img src={`https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/repPhotos/${tech.name}.jpg`} alt='Sales Rep Portrait' onError={(event) => setFallbackAvatar(event)} />
                                                    <span style={this.tableRankStyleObj(index+1)}>{index+1}</span>
                                                </div>
                                            </td>
                                            <td><>
                                                    <div>{tech.name}'s Team</div>
                                                    <div className="text-sm text-uppercase mt-2 mt-sm-0">{tech.location}</div>
                                                </>
                                            </td>
                                            <td className={this.tableCellCss('trueHmod')}>{tech.hmodTier}</td>
                                            <td className={this.tableCellCss('hmod')}>{tech.hmod}</td>
                                            <td className={this.tableCellCss('passOnFirstPercentage')}>{tech.passOnFirstPercentage}%</td>
                                            <td className={this.tableCellCss('installCount')}>{tech.installCount}</td>
                                        </tr>
                                    );
                                })
                        }
                        </tbody>
                    </table>
                    :
                    this.state.aggType === 'Inspection' ?
                    <table className={`${css.FieldKpis__Table} mt-5`}>
                        <thead>
                        <tr>
                            <th colSpan="2">Field Tech</th>
                            <th className={this.tableCellCss('passOnFirstPercentage')}><span>FPR</span></th>
                            <th className={this.tableCellCss('passCount')}><span>Pass</span></th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            // ----- table rows: -----
                            this.state.displayTable
                                // map array to markup:
                                .map((tech, index) => {
                                    return (
                                        <tr key={tech.id}>
                                            <td>
                                                <div className={css.FieldKpis__Table__AvatarContainer}>
                                                    <img src={`https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/repPhotos/${tech.name}.jpg`} alt='Sales Rep Portrait' onError={(event) => setFallbackAvatar(event)} />
                                                    <span style={this.tableRankStyleObj(index+1)}>{index+1}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <>
                                                    <div>{tech.name}</div>
                                                    <div className="text-sm text-uppercase mt-2 mt-sm-0">{tech.location}</div>
                                                </>
                                            </td>
                                            <td className={this.tableCellCss('passOnFirstPercentage')}>{tech.passOnFirstPercentage}%</td>
                                            <td className={this.tableCellCss('passCount')}>{tech.passCount}</td>
                                        </tr>
                                    );
                                })
                        }
                        </tbody>
                    </table>
                    :
                    this.state.aggType === 'Electrical' ?
                    <table className={`${css.FieldKpis__Table} mt-5`}>
                        <thead>
                        <tr>
                            <th colSpan="2">Field Tech</th>
                            <th className={this.tableCellCss('tou')}><span>TOU</span></th>
                            <th className={this.tableCellCss('backup')}><span>Backup</span></th>
                            <th className={this.tableCellCss('mpu')}><span>MPU</span></th>
                            <th className={this.tableCellCss('service')}><span>Service</span></th>
                            <th className={this.tableCellCss('hrsPoints')}><span>Hrs/Points</span></th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            // ----- table rows: -----
                            this.state.displayTable
                                // map array to markup:
                                .map((tech, index) => {
                                    return (
                                        <tr key={tech.id}>
                                            <td>
                                                <div className={css.FieldKpis__Table__AvatarContainer}>
                                                    <img src={`https://v3-portal-file-storage.s3.us-west-2.amazonaws.com/repPhotos/${tech.name}.jpg`} alt='Sales Rep Portrait' onError={(event) => setFallbackAvatar(event)} />
                                                    <span style={this.tableRankStyleObj(index+1)}>{index+1}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <>
                                                    <div>{tech.name}</div>
                                                    <div className="text-sm text-uppercase mt-2 mt-sm-0">{tech.location}</div>
                                                </>
                                            </td>
                                            <td className={this.tableCellCss('tou')}>{tech.tou}</td>
                                            <td className={this.tableCellCss('backup')}>{tech.backup}</td>
                                            <td className={this.tableCellCss('mpu')}>{tech.mpu}</td>
                                            <td className={this.tableCellCss('service')}>{tech.service}</td>
                                            <td className={this.tableCellCss('hrsPoints')}>{tech.hrsPointDisplay}</td>
                                        </tr>
                                    );
                                })
                        }
                        </tbody>
                    </table>
                    :
                    ''
                }
            </div>
        );
    };
};

export default FieldKpis;
